import React, { Component,ReactElement,useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";

import "./contact.css";
import ContactImg from "./ContactImg";
import Input2 from "../../components/html/Input2";
import Textarea from "../../components/html/Textarea";
import Button from "../../components/html/Button";
import { patiApi } from '../../components/misc/PatiApi'
import {handleLogError} from "../../components/misc/Helpers";
import { useTranslation } from "react-i18next";

type ContactFormData = {
  [key: string]: any; 
}
type LoginRequestState = { running?: boolean,isError?:boolean, error?: string,successful?:boolean,message?:string,};
type Props = {theme: ThemeProps,}

export default function Contact({ theme }: Props) {
    const [inputFields, setInputFields] = useState<ContactFormData>({title:"",name:"",organisation:"",phone:"",email:"",message:"",errors:{}});
    const [loginRequestState,setLoginRequestState,] = React.useState<LoginRequestState>({ running: false});
    
    const handleLoginT = (event:React.FormEvent<HTMLFormElement>) => {
			event.preventDefault();
			console.log(inputFields);
			const errorsN:ContactFormData = {};
			for (const el of document.getElementById('form')!.querySelectorAll("[required]")) {
			  if (!(el as HTMLInputElement).reportValidity()) {
			    errorsN[(el as HTMLInputElement).name] = 'invalid';
			  }
  		}
  		inputFields.errors=errorsN;
  		setInputFields(inputFields);
		}
    
    const handleFormChange = (event:React.ChangeEvent<HTMLInputElement>) => {
		   inputFields[event.target.name] = event.target.value;
		   setInputFields(inputFields);
		}
		
    async function handleLogin(event:React.FormEvent<HTMLFormElement>) {
			event.preventDefault();
			console.log(inputFields);
			const errorsN:ContactFormData = {};
			for (const el of document.getElementById('form')!.querySelectorAll("[required]")) {
			  if (!(el as HTMLInputElement).reportValidity()) {
			    errorsN[(el as HTMLInputElement).name] = 'invalid';
			  }
  		}
  		inputFields.errors=errorsN;
  		setInputFields(inputFields);
			
			setLoginRequestState({
				running: true,
			});
			if (!(inputFields.email ||  inputFields.name || inputFields.phone || inputFields.message)) {
				console.log("ERRRRRRRRRRRRR");
				setLoginRequestState({ isError: true,});
				return
			}
	
			patiApi.contact(document.querySelector("form.contactform")!)
				.then(response => {
					setLoginRequestState({
						isError: false,
	          message: response.data,
	          successful: true
					})
				}).catch(error => {
					handleLogError(error)
					setLoginRequestState({ isError: true })
				})
		}
		
		function renderServerError(): ReactElement {
        return (
            <p className="error-message">
              Something went wrong. Please try again later.
            </p>
        )
    }  
  	
  	const { t,i18n } = useTranslation();
		
    return (
		<PageLayout title="Home" theme={theme}>
      <div className="projects-main">
        <div className="basic-projects">
          <Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                {/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
                <ContactImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1 className="projects-heading-text">{t("contact.title")}</h1>
                <p className="projects-header-detail-text subTitle">
                  {t("contact.description")}
                </p>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      
      
      <div className="contact-form-div">
        <h1 className="d-flex justify-content-center">{t("contact.subtitle")}</h1>
        
        <div className="row d-flex align-items-center justify-content-center h-100">
			      <div className="col-md-3 col-lg-3 col-xl-3"></div>
			      <div className="col-md-6 col-lg-6 col-xl-6 ">
			      	<div className="float-end"></div>
			        <form className="contactform pt-5" onSubmit={handleLogin} noValidate={true} id="form">
			        {!loginRequestState.successful && (
			        <div>
			        		<Input2
										name="name" id="name" label={t("contact.label.name")}
										error={inputFields.errors.name && "Please fill in name"}
										disabled={loginRequestState.running} icon="fa-solid fa-user"
										onChange={handleFormChange} {...{required: "required",width: 10}}
									/>
									<Input2
										name="organization" id="organization" label={t("contact.label.company")}
										//{...register("organisation")}
										error={inputFields.errors.organization && "Please fill in Organization"}
										disabled={loginRequestState.running} icon="fa-solid fa-building"
										onChange={handleFormChange} {...{required: "required"}}
									/>
									<Input2
										name="phone" id="phone" label={t("contact.label.phone")} type="tel"
										//{...register("phone")}
										error={inputFields.errors.phone && "Please fill in Telephone"}
										disabled={loginRequestState.running} icon="fa-solid fa-phone"
										onChange={handleFormChange} {...{required: "required",pattern:"[0-9]{3,12}", maxlength:"12" }}
										help="Format: XXXXXXXXX"
									/>
			            <Input2
										name="email" id="email" label={t("contact.label.email")} type="email"
										//{...register("email")}
										error={inputFields.errors.email && "Please fill in Email address"}
										disabled={loginRequestState.running}
										help="We'll never share your email with anyone else." icon="fa-solid fa-envelope"
										onChange={handleFormChange} {...{required: "required"}}
									/>
									<Textarea
										name="message" id="message" label={t("contact.label.comment")} rows={4}
										//{...register("message")}
										error={inputFields.errors.message && "Please write a message"}
										disabled={loginRequestState.running}
										help="..." icon="fa-solid fa-comment"
										{...{required: "required"}}
										onChange={(event) => {inputFields[event.target.name] = event.target.value;setInputFields(inputFields);}}
									/>
												
								<div className="d-grid gap-2">
									{loginRequestState.isError ? renderServerError(): <br></br>}
			          	<Button type="submit" className="btn-lg" buttonClass="primary" disabled={loginRequestState.running}
										>{t("button.send")}</Button>
			          </div>
			          </div>
			          )}
	              {loginRequestState.message && (
	                <div className="form-group">
	                  <div
	                    className={
	                      loginRequestState.successful ? "alert alert-success" : "alert alert-danger"
	                    }
	                    role="alert"
	                  >
	                    {loginRequestState.message}
	                  </div>
	                </div>
	              )}
			             
			        </form>
			      </div>
			      <div className="col-md-3 col-lg-3 col-xl-3"></div>
			    </div>
			    
      </div>
              
      </PageLayout>
    );
}